<template>
  <button class="cta">
    <span v-if="!processing"><slot></slot></span>
    <span v-else v-text="translations.saving"></span>
  </button>
</template>

<script>
import HasTranslatedText from "../../mixins/HasTranslatedText";

export default {
  mixins: [HasTranslatedText],

  props: {
    processing: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
